// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".orgSelect {\n  margin-right: 5px;\n}\n.orgSelect .el-input__inner {\n  line-height: 25px;\n  height: 25px;\n  font-size: 12px;\n}\n.orgSelect .el-input__icon {\n  line-height: 25px;\n}", ""]);
// Exports
module.exports = exports;
